// export default [
//   {
//     id: 1,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10,000.00',
//     listPriceWG2: '1,500.00',
//     totalListPrice: '11,500.00',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5,850.00',
//     STDDISCWG1: '50.00%',
//     SPLDISCWG1: '10.00%',
//     SDRWG1: '0.00%',
//     promotionalDiscountWG1: '0.00%',
//     cumulativeDiscountWG1: '55.00%',
//     STDDISCWG2: '10.00%',
//     SPLDISCWG2: '0.00%',
//     SDRWG2: '0.00%',
//     promotionalDiscountWG2: '0.00%',
//     cumulativeDiscountWG2: '10.00%',
//     margin: '1,100.00',
//     gestureToCustomer: '500',

//     payable: '4,750.00',
//     STDDISCWG1Payable: '50.00%',
//     SPLDISCWG1Payable: '10.00%',
//     SDRWG1Payable: '0.00%',
//     promotionalDiscountWG1Payable: '0.00%',
//     cumulativeDiscountWG1Payable: '66.00%',
//     STDDISCWG2Payable: '10.00%',
//     SPLDISCWG2Payable: '0.00%',
//     SDRWG2PayablePayable: '0.00%',
//     promotionalDiscountWG2Payable: '0.00%',
//     cumulativeDiscountWG2Payable: '10.00%',
//     gestureToCustomerPayable: '0.00',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 2,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 3,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 4,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 5,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 6,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 7,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 8,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 9,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
//   {
//     id: 10,
//     product: "NK",
//     vendorAccount: "45605",
//     customer: "HS-INDIA",
//     territory: "T2",
//     region: 'South',
//     showroom: 'BLR',
//     orderType: "SO",
//     category: "RET",
//     abNumber: '3943840 00',
//     commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
//     uniqueId: "K1",
//     kitchen: '1',
//     furniture: '0',
//     spa: '0',
//     living: '0',
//     listPriceWg1: '10000',
//     listPriceWG2: '1500',
//     totalListPrice: '11500',
//     range1: 'SOFT LACK',
//     priceGroup: 'PG4',
//     color1: '76L-Lava Soft Mat',
//     carcass1: 'SHD-SAHARA',
//     handle1: '591-MATRIX ART HANDLE-BLACK',
    
//     volume: '12/019',
//     weight: '1250/5',
//     noOfPacks: '55',
//     internalContNo: 'HS568',
//     actualContNo: 'TGBU3026236',
//     port: 'Chennai',
//     modeOfShipping: 'SEA',
//     tourNo: '63456',

//     receivable: '5850',
//     STDDISCWG1: '50%',
//     SPLDISCWG1: '10%',
//     SDRWG1: '0%',
//     promotionalDiscountWG1: '0%',
//     cumulativeDiscountWG1: '55%',
//     STDDISCWG2: '10%',
//     SPLDISCWG2: '0%',
//     SDRWG2: '0%',
//     promotionalDiscountWG2: '0%',
//     cumulativeDiscountWG2: '10%',
//     margin: '1100',
//     gestureToCustomer: '500',

//     payable: '4750',
//     STDDISCWG1Payable: '50%',
//     SPLDISCWG1Payable: '10%',
//     SDRWG1Payable: '0%',
//     promotionalDiscountWG1Payable: '0%',
//     cumulativeDiscountWG1Payable: '66%',
//     STDDISCWG2Payable: '10%',
//     SPLDISCWG2Payable: '0%',
//     SDRWG2PayablePayable: '0%',
//     promotionalDiscountWG2Payable: '0%',
//     cumulativeDiscountWG2Payable: '10%',
//     gestureToCustomerPayable: '0',

//     orderReceivedDate: '01/10/2023',
//     orderPlacedDate: '01/10/2023',
//     ABReceivedDate: '30/08/2023',
//     confirmedDate: '01/01/1975',
//     loadingPlanDate: '23/10/2023',
//     loadingPlanWeek: '48',
//     cutoffDate: '29/09/2023',
//     releaseDate: '29/09/2023',
//     actualLoadingDate: '01/01/1975',
//     actualLoadingWeek: '48',

//     SDRApproved: 'A',
//     SDPApproved: '-',
//     PSDApproved: '-',
//     approvalForBooking: 'Yes',
//     approvalToRelease: 'Yes',
//     skipPromotion: 'Yes',

//     reason1: 'Additional order from Customer',
//     reason2: 'Missing-reported by Partner',
//     reason3: 'Wrong Delivery',
//     picture: '',
//   },
// ];


export default [
  {
    "createdDate" : "2024-01-10T23:30:22.252",
    "lastModifiedDate" : "2024-01-10T23:30:22.252",
    "createdByUser" : "Canias",
    "modifiedByUser" : "Canias",
    "id" : "659f990ec16c4e20326ad4a8",
    "documentType" : "SO",
    "documentNum" : "22120070",
    "projectNum" : "AA015201",
    "customerNum" : 30053,
    "customerName" : "AL AQARYIA AL LIBYA CO. LTD.",
    "showroomNum" : 30126,
    "showroomName" : "LIBYA-SHOWROOM2",
    "clientName" : null,
    "country" : "Montenegro",
    "countryCode" : "ME",
    "region" : null,
    "territory" : "6",
    "freightId" : "SEA",
    "freight" : null,
    "slabNum" : 0,
    "custSlabNumsText" : "Slab Number : 0 (Quan Range: 0.00-0.00",
    "vendorNum" : 60001,
    "vendorName" : "NOLTE KUECHEN",
    "vendorShortKey" : "NK",
    "range1Id" : null,
    "range1" : "TORINO LACK",
    "priceGroup1" : "PG6",
    "color1Id" : null,
    "color1" : "Lava Soft Mat",
    "carcass1Id" : null,
    "carcass1" : "SHD-SAHARA",
    "handle1Id" : null,
    "handle1" : "G 208-NORMAL KNOB-MANGANESE BRONZE",
    "range2Id" : null,
    "range2" : null,
    "priceGroup2" : null,
    "color2Id" : null,
    "color2" : null,
    "carcass2Id" : null,
    "carcass2" : null,
    "handle2Id" : null,
    "handle2" : null,
    "range3Id" : null,
    "range3" : null,
    "priceGroup3" : null,
    "color3Id" : null,
    "color3" : null,
    "carcass3Id" : null,
    "carcass3" : null,
    "handle3Id" : null,
    "handle3" : null,
    "abNumber" : "3660913 00",
    "orderStatus" : "LOADED",
    "orderCategory" : "RET",
    "orderPlacedDate" : "2022-12-11",
    "orderPlacedWk" : 50,
    "abReceivedDate" : "2022-12-14T00:00:00",
    "abReceivedWk" : 50,
    "orderCreationWk" : 49,
    "orderCreationDate" : "2022-12-10T23:24:25.453",
    "caniasOrderUser" : "CUSTOMER ORDER",
    "orderCleanDate" : null,
    "orderConfirmedDate" : "2023-01-02T00:00:00",
    "orderConfirmedWk" : 1,
    "cutoffDate" : null,
    "advPaymentDate" : "2022-12-12",
    "accountApprovalStatus" : null,
    "accountApprovalDate" : null,
    "finInvoiceDate" : null,
    "finOrderConfirmed" : null,
    "finOrderConfDate" : null,
    "releaseDate" : null,
    "sdrApprovedDate" : null,
    "sdpApprovedDate" : null,
    "psdApprovedDate" : null,
    "bookingApprovalDate" : null,
    "releaseApprovalDate" : null,
    "lcNumber" : null,
    "assignedTo" : null,
    "assignedDttm" : null,
    "processedOn" : null,
    "loadingWeek" : null,
    "vendorCustomerRefNum" : null,
    "currencyCode" : "EUR",
    "lpWg1" : 37162.00,
    "revisedLpWg1" : 32267.00,
    "stdDiscWg1" : 76.00,
    "afterStdDiscWG1" : null,
    "splDiscWg1" : 0.00,
    "afterSplDiscWg1" : 15326.83,
    "lpWg2" : 1191.00,
    "revisedLpWg2" : 967.00,
    "stdDiscWg2" : 10.00,
    "afterStdDiscWG2" : 918.65,
    "splDiscWg2" : 0.00,
    "afterSplDiscWg2" : 918.65,
    "totalLpWg1Wg2" : 38353.00,
    "totalRevisedLpWg1Wg2" : 33234.00,
    "netWg1" : 17651.95,
    "netWg2" : 1131.45,
    "totalDiscWg1Wg2" : 60.34,
    "grossAmt" : null,
    "subtotal" : null,
    "grandTotal" : 14076.36,
    "promoDiscWg1" : null,
    "afterPromoDiscWg1" : null,
    "sdrWg1" : null,
    "afterSdrWg1" : null,
    "preSalesDiscountWg1" : null,
    "afterPreSalesDiscountWg1" : null,
    "totalDiscWg1" : 62.00,
    "promoDiscWg2" : null,
    "afterPromoDiscWg2" : null,
    "sdrWg2" : null,
    "afterSdrWg2" : null,
    "preSalesDiscountWg2" : null,
    "afterPreSalesDiscountWg2" : null,
    "totalDiscWg2" : 5.00,
    "totalDisc_subCharge" : null,
    "discFromDoc" : null,
    "vatAmt" : null,
    "advanceAmout" : 0.00,
    "advanceFinance" : true,
    "paymentCondition" : null,
    "invoiceAmount" : null,
    "invoiceDate" : null,
    "invoiceReconciled" : false,
    "lpWG1Payable" : 37162.00,
    "rpWG1Payable" : 32267.00,
    "vendorSlabText" : "Slab Number : 0 (Quan Range: 0.0-0.0)",
    "vendorSlabNo" : 0,
    "stdDiscWG1Payable" : 76.00,
    "afterStdDiscWG1Payable" : 7744.08,
    "splDiscWG1Payable" : 5.00,
    "afterSplDiscWG1Payable" : 7356.88,
    "promoDiscWg1Payable" : null,
    "afterPromoDiscWg1Payable" : null,
    "splDisc2WG1Payable" : 0.00,
    "aftersplDisc2WG1Payable" : 7356.88,
    "splDisc3WG1Payable" : 0.00,
    "aftersplDisc3WG1Payable" : 7356.88,
    "totalDiscWG1Payable" : 77.20,
    "lpWG2Payable" : 1191.00,
    "rpWG2Payable" : 967.00,
    "stdDiscWG2Payable" : 10.00,
    "afterStdDiscWG2Payable" : 870.30,
    "splDiscWG2Payable" : 0.00,
    "afterSplDiscWG2Payable" : 870.30,
    "promoDiscWg2Payable" : null,
    "afterPromoDiscWg2Payable" : null,
    "splDisc2WG2Payable" : 0.00,
    "aftersplDisc2WG2Payable" : 870.30,
    "splDisc3WG2Payable" : 0.00,
    "aftersplDisc3WG2Payable" : 870.30,
    "totalDiscWG2Payable" : 10.00,
    "totalLpWG1WG2Payable" : 38353.00,
    "totalRevisedLpWg1Wg2Payable" : 33234.00,
    "netPayable" : 8227.18,
    "netPurchaseInvAmt" : 8786.63,
    "netPayDiff" : -0.01,
    "isNetReconcile" : null,
    "totalDiscWg1Wg2Payable" : 77.20,
    "netWG1Payable" : 7356.88,
    "netWG2Payable" : 870.30,
    "sdpWg1" : null,
    "afterSdpWg1" : null,
    "sdpWg2" : null,
    "afterSdpWg2" : null,
    "sdrStatus" : null,
    "sdrApprovedBy" : null,
    "sdpStatus" : null,
    "sdpApprovedBy" : null,
    "psdStatus" : null,
    "psdApprovedBy" : null,
    "bookingStatus" : null,
    "bookingApprovedBy" : null,
    "releaseStatus" : null,
    "releaseApprovedBy" : null,
    "lineItems" : null,
    "giNumber" : null,
    "giDate" : null,
    "caniasPINumber" : "23010011",
    "orderAttachments" : null,
    "nmeRefNum" : null,
    "commissionName" : "AA015201-NK-152-HATEEM AKREEM",
    "tourNo" : null,
    "total" : null,
    "accountNo" : "43917",
    "plannedLoadingWeek" : 6,
    "actualLoadingWeek" : 5,
    "productionAdviceWeek" : 3,
    "plannedLoadingDate" : "2023-02-06",
    "actualLoadingDate" : "2023-02-03",
    "productionAdviceDate" : "2023-01-17",
    "internalContainerNo" : "AA34",
    "actualContainerNo" : "CMAU6221929",
    "volume" : 13.25900000,
    "weight" : 1435.39900000,
    "noOfPacks" : 43,
    "shippingCode" : null,
    "hubspotRef" : null,
    "specialRemark1" : null,
    "specialRemark2" : null,
    "projectOrder" : false,
    "deleted" : false,
    "vendorContact" : null,
    "vendorMail" : null,
    "questionAndAnnotation" : null,
    "deliveryAddress" : null,
    "orderConfirmedBy" : null,
    "orderConfirmedPhone" : null,
    "orderConfirmedEmail" : null,
    "reason1" : null,
    "reason2" : null,
    "reason3" : null,
    "reason1ImgPath" : null,
    "reason2ImgPath" : null,
    "reason3ImgPath" : null,
    "reasonNote1" : null,
    "reasonNote2" : null,
    "reasonNote3" : null,
    "comments" : null,
    "paymentStatus" : null,
    "paymentTerm" : null,
    "paymentDescription" : null,
    "noOfKitchens" : 1,
    "noOfFurniture" : 0,
    "noOfSpaItems" : null,
    "noOfLivingRmItems" : 0,
    "paymentSchedules" : null,
    "hsCode" : null,
    "description" : null,
    "specialDiscountRequested" : false,
    "requestedContainer" : null,
    "typeName" : null,
    "uniqueId" : null,
    "drwFile" : null,
    "applianceDetail" : null,
    "orderCheckList" : null,
    "drawingFile" : null,
    "revisedDrawingFile" : null,
    "specialDiscountFile" : null,
    "appliancesDetailsharedLater" : null,
    "appliancesDetailNa" : null,
    "checkListDrwFileSupersedes" : null,
    "partForExistingOrder" : null,
    "newPartOrder" : null,
    "parentABNumber" : null,
    "partOrderDetails" : null,
    "sdrWg1Applied" : null,
    "sdrWg2Applied" : null,
    "sdpWg1Applied" : null,
    "sdpWg2Applied" : null,
    "cumltvSdpWg1" : null,
    "cumltvSdpWg2" : null,
    "cumltvSdrWg1" : null,
    "cumltvSdrWg2" : null,
    "_links" : {
      "self" : {
        "href" : "http://192.168.253.27:8090/api/orders/659f990ec16c4e20326ad4a8"
      },
      "order" : {
        "href" : "http://192.168.253.27:8090/api/orders/659f990ec16c4e20326ad4a8"
      },
      "containerPlan" : {
        "href" : "http://192.168.253.27:8090/api/orders/659f990ec16c4e20326ad4a8/containerPlan"
      }
    }
  },
//  {
//   "createdDate" : "2023-12-17T10:47:43.658",
//   "lastModifiedDate" : "2023-12-17T10:47:43.658",
//   "createdByUser" : "Canias",
//   "modifiedByUser" : "Canias",
//   "id" : "657f424ffcbf7f728b34a7ba",
//   "documentType" : "AO",
//   "documentNum" : "23030102",
//   "projectNum" : null,
//   "customerNum" : 30053,
//   "customerName" : "AL AQARYIA AL LIBYA CO. LTD.",
//   "showroomNum" : 30125,
//   "showroomName" : "LIBYA-SHOWROOM1",
//   "clientName" : null,
//   "country" : null,
//   "countryCode" : null,
//   "region" : null,
//   "territory" : 6,
//   "freightId" : "SEA",
//   "freight" : null,
//   "slabNum" : 0,
//   "custSlabNumsText" : "Slab Number : 0 (Quan Range: 0.0-0.0)",
//   "vendorNum" : 60001,
//   "vendorName" : "NOLTE KUECHEN",
//   "vendorShortKey" : "NK",
//   "range1Id" : null,
//   "range1" : "ACCESSORY/POS",
//   "priceGroup1" : "NA",
//   "color1Id" : null,
//   "color1" : "",
//   "carcass1Id" : null,
//   "carcass1" : "",
//   "handle1Id" : null,
//   "handle1" : "",
//   "range2Id" : null,
//   "range2" : null,
//   "priceGroup2" : null,
//   "color2Id" : null,
//   "color2" : null,
//   "carcass2Id" : null,
//   "carcass2" : null,
//   "handle2Id" : null,
//   "handle2" : null,
//   "range3Id" : null,
//   "range3" : null,
//   "priceGroup3" : null,
//   "color3Id" : null,
//   "color3" : null,
//   "carcass3Id" : null,
//   "carcass3" : null,
//   "handle3Id" : null,
//   "handle3" : null,
//   "abNumber" : "3752122 11",
//   "quantity" : 0,
//   "orderStatus" : "LOADED",
//   "orderCategory" : "SHR",
//   "orderPlacedDate" : "2023-03-10",
//   "orderPlacedWk" : 10,
//   "abReceivedDate" : "2023-03-10T00:00:00",
//   "abReceivedWk" : 10,
//   "orderCreationWk" : 10,
//   "orderCreationDate" : "2023-03-10T13:00:22",
//   "caniasOrderUser" : "BINISHVB",
//   "orderCleanDate" : null,
//   "orderConfirmedDate" : "2023-03-10T00:00:00",
//   "orderConfirmedWk" : 10,
//   "cutoffDate" : null,
//   "advPaymentDate" : "2023-03-10",
//   "accountApprovalStatus" : null,
//   "accountApprovalDate" : null,
//   "finInvoiceDate" : null,
//   "finOrderConfirmed" : null,
//   "finOrderConfDate" : null,
//   "releaseDate" : null,
//   "sdrApprovedDate" : null,
//   "sdpApprovedDate" : null,
//   "psdApprovedDate" : null,
//   "bookingApprovalDate" : null,
//   "releaseApprovalDate" : null,
//   "lcNumber" : null,
//   "assignedTo" : null,
//   "assignedDttm" : null,
//   "processedOn" : null,
//   "loadingWeek" : null,
//   "currencyCode" : "EUR",
//   "lpWg1" : 8.00,
//   "revisedLpWg1" : 0.00,
//   "stdDiscWg1" : 88.00,
//   "afterStdDiscWG1" : null,
//   "spclDiscWg1" : 0.00,
//   "afterSpclDiscWg1" : 0.00,
//   "spcl2DiscWg1" : 0.00,
//   "afterspcl2DiscWg1" : 0.00,
//   "spcl3DiscWg1" : 0.00,
//   "afterspcl3DiscWg1" : 0.00,
//   "lpWg2" : 9.00,
//   "revisedLpWg2" : 0.00,
//   "stdDiscWg2" : 10.00,
//   "afterStdDiscWG2" : 0.00,
//   "spclDiscWg2" : 0.00,
//   "afterSpclDiscWg2" : 0.00,
//   "spcl2DiscWg2" : 0.00,
//   "afterspcl2DiscWg2" : 0.00,
//   "spcl3DiscWg2" : 0.00,
//   "afterspcl3DiscWg2" : 0.00,
//   "totalLpWg1Wg2" : 0.00,
//   "totalRevisedLpWg1Wg2" : 0.00,
//   "netWg1" : 0.00,
//   "netWg2" : 0.00,
//   "price" : null,
//   "totalDiscWg1Wg2" : 100.00,
//   "grossAmt" : null,
//   "subtotal" : null,
//   "grandTotal" : 0.00,
//   "sdrWg1" : null,
//   "pdrWg1" : null,
//   "totalDiscWg1" : 75.00,
//   "sdrWg2" : null,
//   "pdrWg2" : null,
//   "totalDiscWg2" : 5.00,
//   "totalDisc_subCharge" : null,
//   "discFromDoc" : null,
//   "vatAmt" : null,
//   "advanceAmout" : 0.00,
//   "advanceFinance" : true,
//   "paymentCondition" : null,
//   "invoiceAmount" : null,
//   "invoiceDate" : null,
//   "invoiceReconciled" : false,
//   "sdrPercentage" : null,
//   "beforeSdr" : null,
//   "afterSdr" : null,
//   "lpWG1Payable" : 0.00,
//   "rpWG1Payable" : 0.00,
//   "vendorSlabText" : "Slab Number : 0 (Quan Range: 0.0-0.0)",
//   "vendorSlabNo" : 0,
//   "discWG1Payable" : 88.00,
//   "afterDiscWG1Payable" : 0.00,
//   "splDiscWG1Payable" : 0.00,
//   "aftersplDiscWG1Payable" : 0.00,
//   "splDisc2WG1Payable" : 0.00,
//   "aftersplDisc2WG1Payable" : 0.00,
//   "splDisc3WG1Payable" : 0.00,
//   "aftersplDisc3WG1Payable" : 0.00,
//   "totDiscWG1Payable" : 88.00,
//   "lpWG2Payable" : 0.00,
//   "rpWG2Payable" : 0.00,
//   "discWG2Payable" : 10.00,
//   "afterDiscWG2Payable" : 0.00,
//   "splDiscWG2Payable" : 0.00,
//   "aftersplDiscWG2Payable" : 0.00,
//   "splDisc2WG2Payable" : 0.00,
//   "aftersplDisc2WG2Payable" : 0.00,
//   "splDisc3WG2Payable" : 0.00,
//   "aftersplDisc3WG2Payable" : 0.00,
//   "totDiscWG2Payable" : 10.00,
//   "totalLpWG1WG2Payable" : 0.00,
//   "totalRevisedLpWg1Wg2Payable" : 0.00,
//   "netPayable" : 0.00,
//   "netPurchaseInvAmt" : 0.00,
//   "netPayDiff" : 0.00,
//   "isNetReconcile" : null,
//   "totDiscWg1Wg2Payable" : 88.00,
//   "netWG1Payable" : 0.00,
//   "netWG2Payable" : 0.00,
//   "sdpWg2" : null,
//   "pdpWg2" : null,
//   "cumltvDiscWg2" : null,
//   "sdpPercentage" : null,
//   "beforeSdp" : null,
//   "afterSdp" : null,
//   "sdrStatus" : null,
//   "sdrApprovedBy" : null,
//   "sdpStatus" : null,
//   "sdpApprovedBy" : null,
//   "psdStatus" : null,
//   "psdApprovedBy" : null,
//   "bookingStatus" : null,
//   "bookingApprovedBy" : null,
//   "releaseStatus" : null,
//   "lineItems" : null,
//   "releaseApprovedBy" : null,
//   "giNumber" : null,
//   "giDate" : null,
//   "caniasPINumber" : "23030046",
//   "orderAttachments" : null,
//   "commissionName" : "AA000140-NK-LUGANOLACK SAMPLE",
//   "tourNo" : null,
//   "total" : null,
//   "accountNo" : "43917",
//   "plannedLoadingWeek" : 13,
//   "actualLoadingWeek" : 12,
//   "productionAdviceWeek" : 12,
//   "plannedLoadingDate" : "2023-03-27",
//   "actualLoadingDate" : "2023-03-24",
//   "productionAdviceDate" : "2023-03-21",
//   "internalContainerNo" : "AA35",
//   "actualContainerNo" : "TXGU7307445",
//   "volume" : 0.00400000,
//   "weight" : 6.00000000,
//   "noOfPacks" : 2,
//   "shippingCode" : null,
//   "hubspotRef" : null,
//   "specialRemark1" : null,
//   "specialRemark2" : null,
//   "projectOrder" : false,
//   "deleted" : false,
//   "vendorContact" : null,
//   "vendorMail" : null,
//   "questionAndAnnotation" : null,
//   "deliveryAddress" : null,
//   "orderConfirmedBy" : null,
//   "orderConfirmedPhone" : null,
//   "orderConfirmedEmail" : null,
//   "reason1" : null,
//   "reason2" : null,
//   "reason3" : null,
//   "reason1ImgPath" : null,
//   "reason2ImgPath" : null,
//   "reason3ImgPath" : null,
//   "reasonNote1" : null,
//   "reasonNote2" : null,
//   "reasonNote3" : null,
//   "comments" : null,
//   "paymentStatus" : null,
//   "paymentTerm" : null,
//   "paymentDescription" : null,
//   "noOfKitchens" : 0,
//   "noOfFurniture" : 0,
//   "noOfSpaItems" : null,
//   "noOfLivingRmItems" : 0,
//   "paymentSchedules" : null,
//   "hsCode" : null,
//   "description" : null,
//   "specialDiscountRequested" : false,
//   "requestedContainer" : null,
//   "typeName" : null,
//   "uniqueId" : null,
//   "drwFile" : null,
//   "applianceDetail" : null,
//   "orderCheckList" : null,
//   "drawingFile" : null,
//   "specialDiscountFile" : null,
//   "_links" : {
//     "self" : {
//       "href" : "http://192.168.253.27:8090/api/orders/657f424ffcbf7f728b34a7ba"
//     },
//     "order" : {
//       "href" : "http://192.168.253.27:8090/api/orders/657f424ffcbf7f728b34a7ba"
//     }
//   }
// }, {
//   "createdDate" : "2023-12-17T10:47:43.675",
//   "lastModifiedDate" : "2023-12-17T10:47:43.675",
//   "createdByUser" : "Canias",
//   "modifiedByUser" : "Canias",
//   "id" : "657f424ffcbf7f728b34a7bc",
//   "documentType" : "AO",
//   "documentNum" : "23040201",
//   "projectNum" : null,
//   "customerNum" : 30053,
//   "customerName" : "AL AQARYIA AL LIBYA CO. LTD.",
//   "showroomNum" : 30125,
//   "showroomName" : "LIBYA-SHOWROOM1",
//   "clientName" : null,
//   "country" : null,
//   "countryCode" : null,
//   "region" : null,
//   "territory" : 6,
//   "freightId" : "SEA",
//   "freight" : null,
//   "slabNum" : 0,
//   "custSlabNumsText" : "Slab Number : 0 (Quan Range: 0.0-0.0)",
//   "vendorNum" : 60001,
//   "vendorName" : "NOLTE KUECHEN",
//   "vendorShortKey" : "NK",
//   "range1Id" : null,
//   "range1" : "ACCESSORY/POS",
//   "priceGroup1" : "NA",
//   "color1Id" : null,
//   "color1" : "",
//   "carcass1Id" : null,
//   "carcass1" : "",
//   "handle1Id" : null,
//   "handle1" : "",
//   "range2Id" : null,
//   "range2" : null,
//   "priceGroup2" : null,
//   "color2Id" : null,
//   "color2" : null,
//   "carcass2Id" : null,
//   "carcass2" : null,
//   "handle2Id" : null,
//   "handle2" : null,
//   "range3Id" : null,
//   "range3" : null,
//   "priceGroup3" : null,
//   "color3Id" : null,
//   "color3" : null,
//   "carcass3Id" : null,
//   "carcass3" : null,
//   "handle3Id" : null,
//   "handle3" : null,
//   "abNumber" : "3803475 00",
//   "quantity" : 0,
//   "orderStatus" : "LOADED",
//   "orderCategory" : "SHR",
//   "orderPlacedDate" : "2023-04-27",
//   "orderPlacedWk" : 17,
//   "abReceivedDate" : "2023-04-28T00:00:00",
//   "abReceivedWk" : 17,
//   "orderCreationWk" : 17,
//   "orderCreationDate" : "2023-04-27T23:59:15",
//   "caniasOrderUser" : "BINISHVB",
//   "orderCleanDate" : null,
//   "orderConfirmedDate" : "2023-04-28T00:00:00",
//   "orderConfirmedWk" : 17,
//   "cutoffDate" : null,
//   "advPaymentDate" : "2023-04-27",
//   "accountApprovalStatus" : null,
//   "accountApprovalDate" : null,
//   "finInvoiceDate" : null,
//   "finOrderConfirmed" : null,
//   "finOrderConfDate" : null,
//   "releaseDate" : null,
//   "sdrApprovedDate" : null,
//   "sdpApprovedDate" : null,
//   "psdApprovedDate" : null,
//   "bookingApprovalDate" : null,
//   "releaseApprovalDate" : null,
//   "lcNumber" : null,
//   "assignedTo" : null,
//   "assignedDttm" : null,
//   "processedOn" : null,
//   "loadingWeek" : null,
//   "currencyCode" : "EUR",
//   "lpWg1" : 5.00,
//   "revisedLpWg1" : 0.00,
//   "stdDiscWg1" : 88.00,
//   "afterStdDiscWG1" : null,
//   "spclDiscWg1" : 0.00,
//   "afterSpclDiscWg1" : 0.00,
//   "spcl2DiscWg1" : 0.00,
//   "afterspcl2DiscWg1" : 0.00,
//   "spcl3DiscWg1" : 0.00,
//   "afterspcl3DiscWg1" : 0.00,
//   "lpWg2" : 5.00,
//   "revisedLpWg2" : 0.00,
//   "stdDiscWg2" : 10.00,
//   "afterStdDiscWG2" : 0.00,
//   "spclDiscWg2" : 0.00,
//   "afterSpclDiscWg2" : 0.00,
//   "spcl2DiscWg2" : 0.00,
//   "afterspcl2DiscWg2" : 0.00,
//   "spcl3DiscWg2" : 0.00,
//   "afterspcl3DiscWg2" : 0.00,
//   "totalLpWg1Wg2" : 0.00,
//   "totalRevisedLpWg1Wg2" : 0.00,
//   "netWg1" : 0.00,
//   "netWg2" : 0.00,
//   "price" : null,
//   "totalDiscWg1Wg2" : 100.00,
//   "grossAmt" : null,
//   "subtotal" : null,
//   "grandTotal" : 0.00,
//   "sdrWg1" : null,
//   "pdrWg1" : null,
//   "totalDiscWg1" : 75.00,
//   "sdrWg2" : null,
//   "pdrWg2" : null,
//   "totalDiscWg2" : 5.00,
//   "totalDisc_subCharge" : null,
//   "discFromDoc" : null,
//   "vatAmt" : null,
//   "advanceAmout" : 0.00,
//   "advanceFinance" : true,
//   "paymentCondition" : null,
//   "invoiceAmount" : null,
//   "invoiceDate" : null,
//   "invoiceReconciled" : false,
//   "sdrPercentage" : null,
//   "beforeSdr" : null,
//   "afterSdr" : null,
//   "lpWG1Payable" : 0.00,
//   "rpWG1Payable" : 0.00,
//   "vendorSlabText" : "Slab Number : 0 (Quan Range: 0.0-0.0)",
//   "vendorSlabNo" : 0,
//   "discWG1Payable" : 88.00,
//   "afterDiscWG1Payable" : 0.00,
//   "splDiscWG1Payable" : 0.00,
//   "aftersplDiscWG1Payable" : 0.00,
//   "splDisc2WG1Payable" : 0.00,
//   "aftersplDisc2WG1Payable" : 0.00,
//   "splDisc3WG1Payable" : 0.00,
//   "aftersplDisc3WG1Payable" : 0.00,
//   "totDiscWG1Payable" : 88.00,
//   "lpWG2Payable" : 0.00,
//   "rpWG2Payable" : 0.00,
//   "discWG2Payable" : 10.00,
//   "afterDiscWG2Payable" : 0.00,
//   "splDiscWG2Payable" : 0.00,
//   "aftersplDiscWG2Payable" : 0.00,
//   "splDisc2WG2Payable" : 0.00,
//   "aftersplDisc2WG2Payable" : 0.00,
//   "splDisc3WG2Payable" : 0.00,
//   "aftersplDisc3WG2Payable" : 0.00,
//   "totDiscWG2Payable" : 10.00,
//   "totalLpWG1WG2Payable" : 0.00,
//   "totalRevisedLpWg1Wg2Payable" : 0.00,
//   "netPayable" : 0.00,
//   "netPurchaseInvAmt" : 0.00,
//   "netPayDiff" : 0.00,
//   "isNetReconcile" : null,
//   "totDiscWg1Wg2Payable" : 88.00,
//   "netWG1Payable" : 0.00,
//   "netWG2Payable" : 0.00,
//   "sdpWg2" : null,
//   "pdpWg2" : null,
//   "cumltvDiscWg2" : null,
//   "sdpPercentage" : null,
//   "beforeSdp" : null,
//   "afterSdp" : null,
//   "sdrStatus" : null,
//   "sdrApprovedBy" : null,
//   "sdpStatus" : null,
//   "sdpApprovedBy" : null,
//   "psdStatus" : null,
//   "psdApprovedBy" : null,
//   "bookingStatus" : null,
//   "bookingApprovedBy" : null,
//   "releaseStatus" : null,
//   "lineItems" : null,
//   "releaseApprovedBy" : null,
//   "giNumber" : null,
//   "giDate" : null,
//   "caniasPINumber" : "23050019",
//   "orderAttachments" : null,
//   "commissionName" : "AA000141-NK-POS PACKAGE MATRIX900",
//   "tourNo" : null,
//   "total" : null,
//   "accountNo" : "43917",
//   "plannedLoadingWeek" : 22,
//   "actualLoadingWeek" : 21,
//   "productionAdviceWeek" : 19,
//   "plannedLoadingDate" : "2023-05-29",
//   "actualLoadingDate" : "2023-05-24",
//   "productionAdviceDate" : "2023-05-09",
//   "internalContainerNo" : "AA37",
//   "actualContainerNo" : "CMAU6105261",
//   "volume" : 0.00600000,
//   "weight" : 1.30000000,
//   "noOfPacks" : 1,
//   "shippingCode" : null,
//   "hubspotRef" : null,
//   "specialRemark1" : null,
//   "specialRemark2" : null,
//   "projectOrder" : false,
//   "deleted" : false,
//   "vendorContact" : null,
//   "vendorMail" : null,
//   "questionAndAnnotation" : null,
//   "deliveryAddress" : null,
//   "orderConfirmedBy" : null,
//   "orderConfirmedPhone" : null,
//   "orderConfirmedEmail" : null,
//   "reason1" : null,
//   "reason2" : null,
//   "reason3" : null,
//   "reason1ImgPath" : null,
//   "reason2ImgPath" : null,
//   "reason3ImgPath" : null,
//   "reasonNote1" : null,
//   "reasonNote2" : null,
//   "reasonNote3" : null,
//   "comments" : null,
//   "paymentStatus" : null,
//   "paymentTerm" : null,
//   "paymentDescription" : null,
//   "noOfKitchens" : 0,
//   "noOfFurniture" : 0,
//   "noOfSpaItems" : null,
//   "noOfLivingRmItems" : 0,
//   "paymentSchedules" : null,
//   "hsCode" : null,
//   "description" : null,
//   "specialDiscountRequested" : false,
//   "requestedContainer" : null,
//   "typeName" : null,
//   "uniqueId" : null,
//   "drwFile" : null,
//   "applianceDetail" : null,
//   "orderCheckList" : null,
//   "drawingFile" : null,
//   "specialDiscountFile" : null,
//   "_links" : {
//     "self" : {
//       "href" : "http://192.168.253.27:8090/api/orders/657f424ffcbf7f728b34a7bc"
//     },
//     "order" : {
//       "href" : "http://192.168.253.27:8090/api/orders/657f424ffcbf7f728b34a7bc"
//     }
//   }
// }
]